import AssignmentDetailContainer from './containers/AssignmentDetailContainer'

export default AssignmentDetailContainer
